/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInChatMessageResponse } from './linkedInChatMessageResponse';
import type { LinkedInChatResponseClassification } from './linkedInChatResponseClassification';
import type { LinkedInChatResponseConnectionState } from './linkedInChatResponseConnectionState';
import type { LinkedInChatResponseDraftBodyJson } from './linkedInChatResponseDraftBodyJson';
import type { LinkedInChatResponseDraftStatus } from './linkedInChatResponseDraftStatus';
import type { LinkedInChatResponseLastMessageDirection } from './linkedInChatResponseLastMessageDirection';
import type { LinkedInChatResponseManualClassification } from './linkedInChatResponseManualClassification';
import type { ScheduledTask } from './scheduledTask';
import type { SidePanelSummary } from './sidePanelSummary';

/**
 * Full ``GET /inbox/chats/{chat_id}`` body.
 */
export interface LinkedInChatResponse {
  id: string;
  channel?: 'linkedin';
  job_candidate_id: string;
  /** @maxLength 200 */
  candidate_name: string;
  candidate_avatar_url?: string | null;
  candidate_headline?: string | null;
  /** @maxLength 500 */
  snippet: string;
  last_message_at: string;
  connection_state: LinkedInChatResponseConnectionState;
  classification?: LinkedInChatResponseClassification;
  manual_classification?: LinkedInChatResponseManualClassification;
  classification_confidence?: number | null;
  draft_status?: LinkedInChatResponseDraftStatus;
  /** @minimum 0 */
  unread_count: number;
  last_message_direction?: LinkedInChatResponseLastMessageDirection;
  last_sender_name?: string | null;
  last_sender_avatar_url?: string | null;
  messages?: LinkedInChatMessageResponse[];
  side_panel_summary: SidePanelSummary;
  scheduled_tasks?: ScheduledTask[];
  draft_body_json?: LinkedInChatResponseDraftBodyJson;
  draft_failure_reason?: string | null;
  linkedin_connected?: boolean;
}
